<template>
  <div class="h-full p-1 overflow-y-auto scrollbar-thin scrollbar-tema">
    <HistoricoViewer 
      v-if="validPermission('K0001')"
      :defaultDateRange="30"
      :maxRecords="5000"
      :showPerformanceWarnings="true"
      :allowLargeExports="false"
      @row-selected="handleRowSelected"
      @data-loaded="handleDataLoaded"
    />
    <div v-else class="flex items-center justify-center h-full">
      <div class="text-center">
        <i class="fas fa-lock text-gray-400 text-4xl mb-4"></i>
        <p class="text-gray-600">Não tem permissões para ver o histórico.</p>
      </div>
  </div>
  </div>
</template>

<script>
import HistoricoViewer from '@/components/historico/HistoricoViewer.vue'
import permissionMixin from '@/permissionMixin.js'

export default {
  mixins: [permissionMixin],
  name: 'HistoricoView',
  components: {
    HistoricoViewer
  },
  data() {
    return {
      selectedRecord: null,
      totalRecords: 0
    }
  },
  methods: {
    handleRowSelected(record) {
      console.log('Selected historico record:', record)
      this.selectedRecord = record
      // Could navigate to related object or show additional details
    },
    
    handleDataLoaded(data) {
      console.log('Historico data loaded:', data)
      this.totalRecords = data.count || 0
    }
  }
}
</script>

